// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { createContext } from 'react';

import generatedIcons from '../icon/generated/icons';
import { IconProviderProps } from './interfaces';

/**
 * Preload the context with the existing icon set.
 * This allows the Icon component to have these icons available in the context even when no IconProvider is used.
 */
export const InternalIconContext = createContext<IconProviderProps.Icons>(generatedIcons);

/** Holds per-component custom icons. Empty by default: components render their built-in icons. */
export const InternalComponentIconsContext = createContext<IconProviderProps.ComponentIcons>({});



// WEBPACK FOOTER //
// /Volumes/workplace/src/icon-provider/context.ts